import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Selfimpact() {
  return (
    <section className="self_impact p-100 bg_blue">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>The Impact Of S.E.L.F By Project Impact</h2>
            <p>
              Through internal collaboration, planning of an agile framework,
              and comprehensive Q/A sessions, Tekrevol was able to build the
              S.E.L.F web app that was capable of increasing productivity and
              efficiency of the students, teachers, parents, and other
              associated staff by providing them on-demand access to the
              educational material and more.
            </p>
            <p>
              The platform was designed to digitally capture and maintain
              records through the C.M.S., ensuring progressive growth and
              performance while releasing the in-house team's pressure to
              maintain the records manually.
            </p>
            <p>
              Lastly, effective communication and access to updated information
              enable individuals to set desired benchmarks, reduce costs
              involved in communication, and lead all the stakeholders on the
              same page with a precise and clear understanding of the current
              situations.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto text-center"
          >
            <div className="challenge_impact">
              <StaticImage
                src="../../../images/case-studies/impact/self_impact.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={840}
                height={783}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Selfimpact;
